import React from "react";
import styled from "styled-components";
import emailjs from "emailjs-com";
// Assets
import ContactImg1 from "../../assets/img/email-1.png";
import ContactImg2 from "../../assets/img/email-2.png";
// import ContactImg3 from "../../assets/img/contact-3.png";

// Function to send email
function sendEmail() {
  emailjs
    .send(
      "service_kn7xyor",
      "template_1xwr9c4",
      {
        to_name: 'Heofon',
        from_name: document.getElementById("email").value,
        subject: document.getElementById("subject").value,
        message: document.getElementById("message").value,
      },
      "aZRlUT2jm5r6wp3BD"
    )
    .then(
      (response) => {
        console.log("Email sent successfully:", response);
        alert("Your message has been sent successfully!");
      },
      (error) => {
        console.error("Email sending failed:", error);
        alert("Oops! Something went wrong. Please try again later.");
      }
    );
}

// Contact component
export default function Contact() {
  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <Container className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Let's get in touch</h1>
            <p className="font13">
              Reach out and let's start a conversation today!
              <br />
            </p>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form>
                <label className="font13">First name:</label>
                <input
                  type="text"
                  id="fname"
                  name="fname"
                  className="font20 extraBold"
                />
                <label className="font13">Email:</label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  className="font20 extraBold"
                />
                <label className="font13">Subject:</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="font20 extraBold"
                />
                <textarea
                  rows="4"
                  cols="50"
                  type="text"
                  id="message"
                  name="message"
                  className="font20 extraBold"
                />
              </Form>
              <SumbitWrapper className="flex">
                  <ButtonInput
                    type="button"
                    value="Send Message"
                    className="pointer animate radius8"
                    style={{ maxWidth: "220px" }}
                    onClick={(e) => {
                      sendEmail();
                    }}
                  />
                </SumbitWrapper>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
              <div
                style={{ width: "70%" }}
                className="flexNullCenter flexColumn"
              >
                <ContactImgBox>
                  <Image src={ContactImg1} alt="office" className="radius6" />
                </ContactImgBox>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const Container = styled.div`
  background-color: #ffffff;
`;
const Image = styled.img`
  height: 580px;
  width: 580px;
  @media (max-width: 860px) {
    display: none;
  }
`;
const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.input`
  border: 1px solid #f4b327;
  background-color: #f4b327;
  color: #f4b327;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #580cd2;
    border: 1px solid #f4b327;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;
const ContactImgBox = styled.div`
  max-width: 180px;
  align-self: flex-end;
  margin: -120px 200px 0px 0px;
`;
const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;
